import Rest from "../Base/Rest";

/**
 * @typedef {ContractEvaluatorsService}
 */
export default class ContractEvaluatorsService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = "/contract-evaluators";
} 